export default "__VITE_ASSET__fd6a6cbf__"